/* LWL — Ürün sayfası (lwl-urun) */
(function () {
	'use strict';
	var root = document.querySelector('[data-lu]');
	if (!root || root.__lu) return;
	root.__lu = 1;

	var D = JSON.parse(root.querySelector('[data-lu-data]').textContent);
	var V = D.v.map(function (a) { return { id: a[0], o: a[1], price: a[2], cmp: a[3], av: a[4], q: a[5], img: a[6] }; });
	var ci = D.ci;
	var nOpt = D.options.length;
	var single = V.length === 1 && nOpt === 1 && V[0].o[0] === 'Default Title';
	var sel = [];
	var mq = window.matchMedia('(min-width: 990px)');
	var $ = function (s, el) { return (el || root).querySelector(s); };
	var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
	var SIZE_KEY = 'lwlBeden:';
	var track = $('[data-lu-track]');
	var items = $$('.lu__m', track);
	var form = $('#lu-form') || $('form');
	var idInput = $('[data-lu-id]');
	var qtyInput = $('[data-lu-qty]');
	var fx = $('[data-lu-fx]');
	var memUsed = false;

	function ls(k, v) {
		try {
			if (v === undefined) return window.localStorage.getItem(k);
			window.localStorage.setItem(k, v);
		} catch (e) { return null; }
	}
	function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
	function money(c) {
		var tc = window.themeCore;
		if (tc && tc.utils && typeof tc.utils.formatMoney === 'function') { try { return tc.utils.formatMoney(c, D.money); } catch (e) {} }
		return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(c / 100) + ' TL';
	}

	/* ---------- Varyant mantığı ---------- */
	function match(v, s, skip) {
		for (var i = 0; i < nOpt; i++) {
			if (i === skip || s[i] == null) continue;
			if (v.o[i] !== s[i]) return false;
		}
		return true;
	}
	function exact() {
		for (var i = 0; i < nOpt; i++) if (sel[i] == null) return null;
		for (var k = 0; k < V.length; k++) if (match(V[k], sel)) return V[k];
		return null;
	}
	function best() {
		var e = exact();
		if (e) return e;
		var f = null;
		for (var k = 0; k < V.length; k++) {
			if (match(V[k], sel)) { if (V[k].av) return V[k]; if (!f) f = V[k]; }
		}
		return f || V[0];
	}
	function valState(i, val) {
		/* bu seçenek değeri, diğer seçimlerle birlikte stokta mı; adet */
		var s = sel.slice(); s[i] = val;
		var found = null;
		for (var k = 0; k < V.length; k++) {
			var v = V[k];
			if (v.o[i] !== val) continue;
			if (!match(v, s, -1)) continue;
			if (v.av) return { av: true, q: v.q };
			found = v;
		}
		return { av: false, q: 0, exists: !!found };
	}
	function need() {
		for (var i = 0; i < nOpt; i++) if (i !== ci && sel[i] == null) return i;
		return -1;
	}
	function optLabel(i) { var n = D.options[i] || ''; return /^(boyut|size)$/i.test(n) ? 'Beden' : n; }
	function colorName() { return ci >= 0 ? sel[ci] : ''; }

	/* başlangıç */
	(function initSel() {
		var start = null, vid = null;
		try { vid = new URLSearchParams(location.search).get('variant'); } catch (e) {}
		V.forEach(function (v) { if (String(v.id) === String(vid)) start = v; });
		if (!start) V.forEach(function (v) { if (v.id === D.cur) start = v; });
		if (!start) start = V[0];
		for (var i = 0; i < nOpt; i++) sel[i] = null;
		if (ci >= 0) sel[ci] = start.o[ci];
		for (var j = 0; j < nOpt; j++) {
			if (j === ci) continue;
			var vals = D.options.length ? uniq(j) : [];
			if (vals.length === 1) { sel[j] = vals[0]; continue; }
			var mem = ls(SIZE_KEY + D.options[j]);
			if (mem && vals.indexOf(mem) > -1 && valState(j, mem).av) { sel[j] = mem; memUsed = true; }
		}
	})();
	function uniq(i) {
		var out = [];
		V.forEach(function (v) { if (out.indexOf(v.o[i]) === -1) out.push(v.o[i]); });
		return out;
	}

	/* ---------- Çizim ---------- */
	function render() {
		var v = best();
		var full = exact();
		/* renk */
		$$('[data-lu-color]').forEach(function (b) {
			var on = b.getAttribute('data-lu-color') === colorName();
			b.classList.toggle('is-sel', on);
			b.setAttribute('aria-checked', on ? 'true' : 'false');
		});
		/* seçenekler */
		$$('[data-lu-opt]').forEach(function (box) {
			var i = +box.getAttribute('data-lu-opt');
			var lab = $('[data-lu-val]', box);
			if (i === ci) { if (lab) lab.textContent = sel[i] || ''; return; }
			if (lab) {
				lab.textContent = sel[i] != null ? sel[i] : 'Lütfen seçin';
				lab.classList.toggle('is-need', sel[i] == null);
			}
			$$('[data-lu-v]', box).forEach(function (b) {
				var val = b.getAttribute('data-lu-v');
				var st = valState(i, val);
				var on = sel[i] === val;
				b.classList.toggle('is-sel', on);
				b.classList.toggle('is-out', !st.av);
				b.setAttribute('aria-checked', on ? 'true' : 'false');
				b.setAttribute('aria-label', val + (st.av ? '' : ' (tükendi, gelince haber ver)'));
			});
		});
		/* fiyat */
		var now = $('[data-lu-now]'), was = $('[data-lu-was]'), off = $('[data-lu-off]'), save = $('[data-lu-save]');
		if (now) now.textContent = money(v.price);
		var disc = v.cmp > v.price;
		if (was) { was.hidden = !disc; if (disc) was.textContent = money(v.cmp); }
		if (off) { off.hidden = !disc; if (disc) off.textContent = '-%' + Math.round((v.cmp - v.price) * 100 / v.cmp); }
		if (save) save.textContent = disc ? money(v.cmp - v.price) + ' tasarruf ediyorsunuz' : '';
		/* stok notu */
		var stock = $('[data-lu-stock]');
		if (stock) stock.textContent = full && full.av && full.q > 0 && full.q <= 3 ? (nOpt > (ci >= 0 ? 1 : 0) && !single ? 'Bu bedende son ' : 'Son ') + full.q + ' ürün kaldı' : '';
		var mem = $('[data-lu-mem]');
		if (mem) mem.textContent = memUsed && full ? 'Önceki seçimine göre ' + full.o.filter(function (x, i) { return i !== ci; }).join(' / ') + ' seçildi.' : '';
		/* form */
		if (idInput) idInput.value = v.id;
		if (qtyInput) {
			var max = full && full.q > 0 ? full.q : 99;
			if (+qtyInput.value > max) qtyInput.value = max;
			qtyInput.max = max;
			var mb = $('[data-lu-q="-1"]'), pb = $('[data-lu-q="1"]');
			if (mb) mb.disabled = +qtyInput.value <= 1;
			if (pb) pb.disabled = +qtyInput.value >= max;
		}
		var notify = full && !full.av;
		var allOut = !V.some(function (x) { return x.av; });
		$$('[data-lu-atc]', document).forEach(function (b) {
			b.classList.toggle('is-notify', !!notify || allOut);
			var t = $('[data-lu-atl]', b);
			if (t) t.textContent = (notify || allOut) ? 'Gelince Haber Ver' : 'Sepete Ekle';
		});
		/* sabit çubuk özeti */
		var fxs = $('[data-lu-fxs]');
		if (fxs) fxs.textContent = [colorName(), full ? full.o.filter(function (x, i) { return i !== ci; }).join(' / ') : ''].filter(Boolean).join(' · ') + ' — ' + money(v.price);
		var fxi = $('[data-lu-fximg]');
		if (fxi && v.img) fxi.src = v.img;
		/* adres */
		try {
			var u = new URL(location.href);
			if (u.searchParams.get('variant') !== String(v.id)) {
				u.searchParams.set('variant', v.id);
				history.replaceState(history.state, '', u.toString());
			}
		} catch (e) {}
		try { document.dispatchEvent(new CustomEvent('lwl:variant', { detail: { variant: v, complete: !!full, color: colorName(), handle: D.handle } })); } catch (e) {}
	}

	/* ---------- Galeri ---------- */
	var curGroup = [];
	function groupOf(c) {
		var g = items.filter(function (m) { return ci < 0 || m.getAttribute('data-c') === c; });
		return g.length ? g : items;
	}
	function layoutDesktop() {
		curGroup = groupOf(colorName());
		items.forEach(function (m) { m.classList.remove('is-cur', 'is-hero', 'is-half'); });
		var n = curGroup.length, cls = [];
		for (var k = 0; k < n; k++) cls[k] = '';
		if (n === 1) cls[0] = 'is-hero';
		else if (n === 2 || n === 4) for (k = 0; k < n; k++) cls[k] = 'is-half';
		else {
			cls[0] = 'is-hero';
			var rest = (n - 3) % 3;
			if (rest === 2) { cls[n - 1] = cls[n - 2] = 'is-half'; }
			else if (rest === 1) { for (k = n - 4; k < n; k++) cls[k] = 'is-half'; }
		}
		curGroup.forEach(function (m, i) {
			m.classList.add('is-cur');
			if (cls[i]) m.classList.add(cls[i]);
			var im = m.querySelector('img');
			if (im && im.loading === 'lazy' && i < 3) im.loading = 'eager';
		});
		$$('[data-lu-oc]').forEach(function (b) { b.classList.toggle('is-cur', b.getAttribute('data-lu-oc') === colorName()); });
	}
	function slideIndex() {
		var w = track.clientWidth || 1;
		return Math.max(0, Math.min(items.length - 1, Math.round(track.scrollLeft / w)));
	}
	function updateBar() {
		var bar = $('[data-lu-bar]'), cnt = $('[data-lu-cnt]');
		if (!bar) return;
		var idx = slideIndex();
		var cur = items[idx];
		var g = groupOf(cur ? cur.getAttribute('data-c') : colorName());
		var pos = g.indexOf(cur);
		if (bar.childElementCount !== g.length || bar.getAttribute('data-c') !== (cur && cur.getAttribute('data-c'))) {
			bar.innerHTML = g.map(function () { return '<i></i>'; }).join('');
			bar.setAttribute('data-c', cur ? cur.getAttribute('data-c') : '');
		}
		Array.prototype.forEach.call(bar.children, function (s, i) { s.classList.toggle('is-on', i === pos); });
		if (cnt) cnt.textContent = (ci >= 0 && cur ? cur.getAttribute('data-c') + ' · ' : '') + (pos + 1) + '/' + g.length;
	}
	function goToColor(c, smooth) {
		if (mq.matches) { layoutDesktop(); return; }
		var first = items.filter(function (m) { return m.getAttribute('data-c') === c; })[0];
		if (!first) return;
		var cur = items[slideIndex()];
		if (cur && cur.getAttribute('data-c') === c) return;
		var left = first.offsetLeft - track.offsetLeft;
		var far = Math.abs(left - track.scrollLeft) > track.clientWidth * 2.5;
		if (far) smooth = false;
		suppress = true;
		track.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
		clearTimeout(supT);
		supT = setTimeout(function () { suppress = false; updateBar(); }, smooth ? 900 : 120);
	}
	var suppress = false, supT, scT;
	track.addEventListener('scroll', function () {
		if (mq.matches) return;
		updateBar();
		clearTimeout(scT);
		scT = setTimeout(function () {
			if (suppress || ci < 0) return;
			var cur = items[slideIndex()];
			var c = cur && cur.getAttribute('data-c');
			if (c && c !== colorName()) { sel[ci] = c; memUsed = false; render(); }
		}, 140);
	}, { passive: true });

	function setColor(c, smooth) {
		if (ci < 0) return;
		sel[ci] = c;
		render();
		goToColor(c, smooth);
	}
	function applyMode() {
		if (mq.matches) { layoutDesktop(); }
		else {
			items.forEach(function (m) { m.classList.remove('is-cur', 'is-hero', 'is-half'); });
			goToColor(colorName(), false);
			updateBar();
		}
		stickyTop();
	}
	if (mq.addEventListener) mq.addEventListener('change', applyMode); else if (mq.addListener) mq.addListener(applyMode);

	/* ---------- Büyük görsel ---------- */
	var lb;
	function openLb(startItem) {
		var g = mq.matches ? curGroup : groupOf(startItem.getAttribute('data-c'));
		var imgs = g.map(function (m) { return m.querySelector('img'); }).filter(Boolean);
		if (!imgs.length) return;
		if (!lb) {
			lb = document.createElement('div');
			lb.className = 'lu-lb lu-x';
			lb.innerHTML = '<div class="lu-lb__t" data-t></div><button type="button" class="lu-lb__x" aria-label="Kapat">' + icon('x') + '</button><button type="button" class="lu-lb__a lu-lb__a--p" aria-label="Önceki">' + icon('l') + '</button><button type="button" class="lu-lb__a lu-lb__a--n" aria-label="Sonraki">' + icon('r') + '</button><span class="lu-lb__c" data-c></span>';
			document.body.appendChild(lb);
			var t = lb.querySelector('[data-t]');
			lb.querySelector('.lu-lb__x').addEventListener('click', function () { closeLb(); });
			lb.querySelector('.lu-lb__a--p').addEventListener('click', function () { t.scrollBy({ left: -t.clientWidth, behavior: 'smooth' }); });
			lb.querySelector('.lu-lb__a--n').addEventListener('click', function () { t.scrollBy({ left: t.clientWidth, behavior: 'smooth' }); });
			t.addEventListener('scroll', function () { lbCount(); }, { passive: true });
			t.addEventListener('click', function (e) {
				var f = e.target.closest('figure');
				if (!f) return;
				if (zoomFig === f) { if (zLastDrag && Date.now() - zLastDrag < 300) return; unzoom(); return; }
				unzoom();
				var im = f.querySelector('img');
				if (!im) return;
				zoomFig = f;
				setOrigin(im, e.clientX, e.clientY);
				f.classList.add('is-zoom');
				lb.classList.add('is-zoomed');
				zScale(ZS);
			});
			t.addEventListener('pointermove', function (e) {
				if (!zoomFig || !zBase) return;
				if (e.pointerType === 'mouse') { zAim(e.clientX, e.clientY); return; }
				if (!zDrag) return;
				var k = 100 / Math.max(0.2, zS - 1);
				zT.x = clamp(zDrag.ox - (e.clientX - zDrag.x) / zBase.width * k);
				zT.y = clamp(zDrag.oy - (e.clientY - zDrag.y) / zBase.height * k);
				if (!zRaf) zRaf = requestAnimationFrame(zStep);
			});
			t.addEventListener('pointerdown', function (e) {
				if (zoomFig && e.pointerType !== 'mouse') zDrag = { x: e.clientX, y: e.clientY, ox: zT.x, oy: zT.y, t: Date.now() };
			});
			function dist(a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); }
			t.addEventListener('touchstart', function (e) {
				if (e.touches.length !== 2) return;
				var f = e.target.closest('figure'), im = f && f.querySelector('img');
				if (!im) return;
				e.preventDefault();
				var mx = (e.touches[0].clientX + e.touches[1].clientX) / 2, my = (e.touches[0].clientY + e.touches[1].clientY) / 2;
				if (zoomFig !== f) {
					unzoom();
					zoomFig = f;
					setOrigin(im, mx, my);
					f.classList.add('is-zoom');
					lb.classList.add('is-zoomed');
				}
				zDrag = null;
				zPinch = { d: dist(e.touches[0], e.touches[1]), s: zS };
			}, { passive: false });
			t.addEventListener('touchmove', function (e) {
				if (zPinch && e.touches.length === 2) {
					e.preventDefault();
					zScale(Math.max(1, Math.min(4, zPinch.s * dist(e.touches[0], e.touches[1]) / zPinch.d)));
					return;
				}
				if (zoomFig) e.preventDefault();
			}, { passive: false });
			t.addEventListener('touchend', function (e) {
				if (!zPinch || e.touches.length >= 2) return;
				zPinch = null;
				zLastDrag = Date.now();
				if (zS < 1.15) unzoom();
				else if (e.touches.length === 1) zDrag = { x: e.touches[0].clientX, y: e.touches[0].clientY, ox: zT.x, oy: zT.y };
			});
			t.addEventListener('pointerup', function (e) { if (zDrag && (Math.abs(e.clientX - zDrag.x) > 8 || Math.abs(e.clientY - zDrag.y) > 8)) zLastDrag = Date.now(); zDrag = null; });
		}
		var tr = lb.querySelector('[data-t]');
		tr.innerHTML = imgs.map(function (im) {
			var src = (im.currentSrc || im.src).replace(/width=\d+/, 'width=1800');
			return '<figure><img src="' + esc(src) + '" alt="' + esc(im.alt) + '"></figure>';
		}).join('');
		lb.classList.add('is-open');
		document.body.classList.add('lu-noscroll');
		var start = Math.max(0, g.indexOf(startItem));
		requestAnimationFrame(function () { tr.scrollLeft = start * tr.clientWidth; lbCount(); });
		try { history.pushState({ luLb: 1 }, ''); } catch (e) {}
	}
	var zoomFig = null, zBase = null, zT = { x: 50, y: 50 }, zC = { x: 50, y: 50 }, zRaf = 0, zDrag = null;
	var ZS = 2.4, zS = 1, zLastDrag = 0, zPinch = null;
	function zScale(s) {
		zS = s;
		var im = zoomFig && zoomFig.querySelector('img');
		if (im) im.style.transform = 'scale(' + s + ')';
	}
	function clamp(v) { return Math.max(0, Math.min(100, v)); }
	function zApply() { var im = zoomFig && zoomFig.querySelector('img'); if (im) im.style.transformOrigin = zC.x + '% ' + zC.y + '%'; }
	function zStep() {
		zRaf = 0;
		if (!zoomFig) return;
		zC.x += (zT.x - zC.x) * 0.22; zC.y += (zT.y - zC.y) * 0.22;
		zApply();
		if (Math.abs(zT.x - zC.x) > 0.05 || Math.abs(zT.y - zC.y) > 0.05) zRaf = requestAnimationFrame(zStep);
	}
	function zAim(x, y) {
		if (!zBase) return;
		zT.x = clamp((x - zBase.left) / zBase.width * 100);
		zT.y = clamp((y - zBase.top) / zBase.height * 100);
		if (!zRaf) zRaf = requestAnimationFrame(zStep);
	}
	function setOrigin(im, x, y) {
		zBase = im.getBoundingClientRect();
		zT.x = zC.x = clamp((x - zBase.left) / zBase.width * 100);
		zT.y = zC.y = clamp((y - zBase.top) / zBase.height * 100);
		im.style.transition = 'none';
		zApply();
		void im.offsetWidth;
		im.style.transition = '';
	}
	function unzoom() {
		if (zoomFig) { zoomFig.classList.remove('is-zoom'); var zi = zoomFig.querySelector('img'); if (zi) zi.style.transform = ''; }
		zoomFig = null; zBase = null; zDrag = null; zPinch = null; zS = 1;
		if (lb) lb.classList.remove('is-zoomed');
	}
	function lbCount() {
		var t = lb.querySelector('[data-t]');
		var n = t.children.length, i = Math.round(t.scrollLeft / (t.clientWidth || 1)) + 1;
		lb.querySelector('[data-c]').textContent = i + ' / ' + n;
	}
	function closeLb(fromPop) {
		if (!lb || !lb.classList.contains('is-open')) return;
		unzoom();
		lb.classList.remove('is-open');
		document.body.classList.remove('lu-noscroll');
		if (fromPop !== true) { try { if (history.state && history.state.luLb) history.back(); } catch (e) {} }
	}
	window.addEventListener('popstate', function () { closeLb(true); closeSheet(true); });
	items.forEach(function (m) {
		m.addEventListener('click', function () { if (m.querySelector('img')) openLb(m); });
	});

	/* ---------- Simgeler ---------- */
	function icon(n) {
		var p = {
			x: '<path d="M6 6l12 12M18 6 6 18"/>',
			l: '<path d="M15 5l-7 7 7 7"/>',
			r: '<path d="M9 5l7 7-7 7"/>',
			link: '<path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1"/><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1"/>',
			more: '<circle cx="5" cy="12" r="1.3"/><circle cx="12" cy="12" r="1.3"/><circle cx="19" cy="12" r="1.3"/>',
			mail: '<rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3.5 6 8.5 7 8.5-7"/>'
		};
		return '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">' + p[n] + '</svg>';
	}
	var WA = '<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.1.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.2-1.4-.1-.1-.3-.2-.6-.3zM12 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.7 1 1-3.6-.2-.4C2.7 15.6 2.2 13.8 2.2 12 2.2 6.6 6.6 2.2 12 2.2c2.6 0 5.1 1 6.9 2.9 1.8 1.8 2.9 4.3 2.9 6.9 0 5.4-4.4 9.8-9.8 9.8zM20.5 3.5C18.2 1.2 15.2 0 12 0 5.4 0 0 5.4 0 12c0 2.1.6 4.2 1.6 6L0 24l6.2-1.6c1.8 1 3.8 1.5 5.8 1.5 6.6 0 12-5.4 12-12 0-3.2-1.2-6.2-3.5-8.4z"/></svg>';
	var IG = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg>';

	/* ---------- Bildirim ---------- */
	var toastEl, toastT;
	function toast(msg, ms) {
		if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'lu-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
		toastEl.textContent = msg;
		requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
		clearTimeout(toastT);
		toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, ms || 2600);
	}

	/* ---------- Alt paneller ---------- */
	var sheet, sheetBody, sheetOpen = false;
	function openSheet(html, onReady) {
		if (!sheet) {
			sheet = document.createElement('div');
			sheet.className = 'lu-sh lu-x';
			sheet.innerHTML = '<div class="lu-sh__bg" data-close></div><div class="lu-sh__p" role="dialog" aria-modal="true"><div class="lu-sh__grab"></div><div data-b></div></div>';
			document.body.appendChild(sheet);
			sheetBody = sheet.querySelector('[data-b]');
			sheet.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) closeSheet(); });
			document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSheet(); closeLb(); } });
		}
		sheetBody.innerHTML = html;
		sheet.classList.add('is-open');
		sheetOpen = true;
		document.body.classList.add('lu-noscroll');
		syncFx();
		try { history.pushState({ luSh: 1 }, ''); } catch (e) {}
		if (onReady) onReady(sheetBody);
	}
	function closeSheet(fromPop) {
		if (!sheet || !sheetOpen) return;
		sheet.classList.remove('is-open');
		sheetOpen = false;
		document.body.classList.remove('lu-noscroll');
		syncFx();
		if (fromPop !== true) { try { if (history.state && history.state.luSh) history.back(); } catch (e) {} }
	}
	function head(sub) {
		var v = best();
		return '<div class="lu-sh__h"><img src="' + esc(v.img || D.img) + '" alt=""><div><b>' + esc(D.title) + '</b><span>' + esc(sub) + '</span></div><button type="button" class="lu-sh__x" data-close aria-label="Kapat">' + icon('x') + '</button></div>';
	}

	/* Hızlı beden paneli */
	function sizeSheet(i) {
		var box = $('[data-lu-opt="' + i + '"]');
		var btns = $$('[data-lu-v]', box).map(function (b) {
			var val = b.getAttribute('data-lu-v');
			var st = valState(i, val);
			return '<button type="button" class="lu__szb' + (st.av ? '' : ' is-out') + '" data-q="' + esc(val) + '">' + b.innerHTML + '</button>';
		}).join('');
		var guide = $('[data-lu-guide]') ? '<button type="button" class="lu__guide" data-g>Beden rehberi</button>' : '';
		var long = $('[data-lu-sz]', box).classList.contains('is-long') ? ' is-long' : '';
		openSheet(head((colorName() ? colorName() + ' · ' : '') + money(best().price)) +
			'<div class="lu-sh__t"><span>' + esc(optLabel(i)) + ' seç, hemen sepete ekleyelim</span>' + guide + '</div>' +
			'<div class="lu__sz' + long + '"' + (long ? '' : ' style="--n:' + Math.min(4, btns.split('data-q=').length - 1 > 4 ? 3 : btns.split('data-q=').length - 1) + '"') + '>' + btns + '</div><p class="lu-note">Tükenen bedene dokunursan, gelince haber veririz.</p>',
			function (b) {
				b.addEventListener('click', function (e) {
					var g = e.target.closest('[data-g]');
					if (g) { closeSheet(); openGuide(); return; }
					var q = e.target.closest('[data-q]');
					if (!q) return;
					var val = q.getAttribute('data-q');
					sel[i] = val; memUsed = false;
					ls(SIZE_KEY + D.options[i], val);
					render();
					closeSheet();
					var nx = need();
					if (nx > -1) { setTimeout(function () { sizeSheet(nx); }, 250); return; }
					var v = exact();
					if (v && v.av) add('Hızlı beden paneli'); else setTimeout(notifySheet, 250);
				});
			});
	}
	function openGuide() {
		var d = $('[data-lu-sg]');
		if (!d) return;
		d.open = true;
		d.scrollIntoView({ behavior: 'smooth', block: 'start' });
	}

	/* Stok bildirimi (LWL Bildirim sunucusu; hata olursa tema iletişim formu) */
	var NOTIFY_API = 'https://lwl-bildirim.lwlturkey34.workers.dev/abone';
	function notifySheet() {
		var v = exact() || best();
		var tpl = $('[data-lu-notify-tpl]');
		var label = v.o.filter(function (x) { return x !== 'Default Title'; }).join(' / ');
		openSheet(head(label + ' şu an tükendi') + '<p style="margin:0 0 12px;font-size:14px;line-height:1.5;color:#4a3a2c">Bu seçenek stoğa girince e-postayla haber verelim.</p>' + (tpl ? tpl.innerHTML : ''), function (b) {
			var body = b.querySelector('[data-lu-nbody]');
			if (body) body.value = 'Stok bildirimi: ' + D.title + ' — ' + label + ' — ' + location.origin + D.url + '?variant=' + v.id;
			var f = b.querySelector('form');
			if (!f || !window.fetch) return;
			f.addEventListener('submit', function (e) {
				if (f._native) return;
				e.preventDefault();
				var btn = f.querySelector('button[type=submit]'), msg = f.querySelector('[data-lu-nmsg]');
				var em = f.querySelector('[type=email]'), iz = f.querySelector('[name=izin]'), web = f.querySelector('[name=web]');
				if (btn) btn.disabled = true;
				if (msg) msg.textContent = '';
				fetch(NOTIFY_API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: em ? em.value.trim() : '', variant_id: v.id, handle: D.handle, izin: !!(iz && iz.checked), web: web ? web.value : '' }) })
					.then(function (r) { return r.json(); })
					.then(function (j) {
						if (j && j.ok) { closeSheet(); toast('✓ Tamam! Stoğa girince e-postayla haber vereceğiz.', 4000); return; }
						if (j && j.hata === 'eposta') { if (btn) btn.disabled = false; if (msg) msg.textContent = 'E-posta adresini kontrol eder misin?'; return; }
						throw 0;
					})
					.catch(function () { f._native = true; f.submit(); });
			});
		});
	}

	/* ---------- Sepete ekle ---------- */
	var busy = false;
	function add(src) {
		if (busy) return;
		var v = exact();
		if (!v) return;
		busy = true;
		var btns = $$('[data-lu-atc]', document);
		btns.forEach(function (b) { b.classList.add('is-busy'); });
		var msg = $('[data-lu-msg]');
		if (msg) msg.textContent = '';
		var item = { id: v.id, quantity: Math.max(1, +qtyInput.value || 1) };
		if (src) item.properties = { _kaynak: src };
		fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
			body: JSON.stringify({ items: [item] })
		}).then(function (r) {
			return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Ürün sepete eklenemedi.'); return d; });
		}).then(function () {
			btns.forEach(function (b) {
				b.classList.remove('is-busy'); b.classList.add('is-done');
				var t = $('[data-lu-atl]', b); if (t) t.textContent = '✓ Sepete eklendi';
			});
			setTimeout(function () { btns.forEach(function (b) { b.classList.remove('is-done'); }); render(); }, 1800);
			openCart();
		}).catch(function (err) {
			btns.forEach(function (b) { b.classList.remove('is-busy'); });
			if (msg) msg.textContent = err.message;
			toast(err.message, 4000);
		}).then(function () { busy = false; });
	}
	function openCart() {
		var tc = window.themeCore;
		var bus = tc && tc.EventBus;
		if (bus && bus.all && bus.all()['cart:drawer:refresh-and-open']) { bus.emit('cart:drawer:refresh-and-open'); return; }
		if (tc && tc.CartApi && tc.CartApi.makeRequest) {
			tc.CartApi.makeRequest(tc.CartApi.actions.GET_CART).then(function () { if (bus) bus.emit('cart:drawer:open'); });
			return;
		}
		location.href = '/cart';
	}
	function onBuy(e) {
		if (e) e.preventDefault();
		if (!V.some(function (x) { return x.av; })) { notifySheet(); return; }
		var n = need();
		if (n > -1) {
			var box = $('[data-lu-opt="' + n + '"]');
			var r = box.getBoundingClientRect();
			var visible = r.top > 60 && r.bottom < window.innerHeight - 80;
			if (!mq.matches || !visible) {
				if (!mq.matches) { sizeSheet(n); return; }
				box.scrollIntoView({ behavior: 'smooth', block: 'center' });
			}
			box.classList.add('is-need');
			box.classList.remove('is-shake'); void box.offsetWidth; box.classList.add('is-shake');
			return;
		}
		var v = exact();
		if (v && !v.av) { notifySheet(); return; }
		add();
	}
	if (form) form.addEventListener('submit', onBuy);
	$$('[data-lu-atc]').forEach(function (b) { if (b.type !== 'submit') b.addEventListener('click', onBuy); });

	/* ---------- Seçim tıklamaları ---------- */
	root.addEventListener('click', function (e) {
		var c = e.target.closest('[data-lu-color]');
		if (c) { memUsed = false; setColor(c.getAttribute('data-lu-color'), true); return; }
		var oc = e.target.closest('[data-lu-oc]');
		if (oc) {
			setColor(oc.getAttribute('data-lu-oc'), true);
			var g = $('.lu__gal');
			if (g && g.getBoundingClientRect().top < 0) window.scrollTo({ top: window.scrollY + g.getBoundingClientRect().top - 90, behavior: 'smooth' });
			return;
		}
		var s = e.target.closest('[data-lu-v]');
		if (s) {
			var box = s.closest('[data-lu-opt]');
			var i = +box.getAttribute('data-lu-opt');
			var val = s.getAttribute('data-lu-v');
			sel[i] = val; memUsed = false;
			box.classList.remove('is-need');
			if (valState(i, val).av) ls(SIZE_KEY + D.options[i], val);
			render();
			return;
		}
		var q = e.target.closest('[data-lu-q]');
		if (q) {
			var nv = Math.max(1, Math.min(+qtyInput.max || 99, (+qtyInput.value || 1) + +q.getAttribute('data-lu-q')));
			qtyInput.value = nv; render(); return;
		}
		if (e.target.closest('[data-lu-guide]')) { openGuide(); return; }
		if (e.target.closest('[data-lu-share]')) { shareSheet(); return; }
		if (e.target.closest('[data-lu-wa]')) { shareTo('whatsapp', 'ask'); return; }
	});
	if (qtyInput) qtyInput.addEventListener('change', function () { qtyInput.value = Math.max(1, Math.min(+qtyInput.max || 99, parseInt(qtyInput.value, 10) || 1)); render(); });

	/* ---------- Paylaşım ---------- */
	var MSG = {
		ask: 'Bunu beğendim, sence bana yakışır mı? 👀',
		gift: 'Hediye düşünen olursa… bunu çok beğendim 😍',
		link: ''
	};
	var msgKind = 'ask';
	function shareUrl(src) {
		var v = best();
		return location.origin + D.url + '?variant=' + v.id + '&utm_source=' + src + '&utm_medium=social&utm_campaign=urun_paylas';
	}
	function shareText(kind, src) {
		var t = MSG[kind];
		var line = D.title + (colorName() ? ' (' + colorName() + ')' : '');
		return (t ? t + '\n' + line + '\n' : '') + shareUrl(src);
	}
	function copy(text) {
		if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return fallbackCopy(text); });
		return Promise.resolve(fallbackCopy(text));
	}
	function fallbackCopy(text) {
		var ta = document.createElement('textarea');
		ta.value = text; ta.setAttribute('readonly', ''); ta.style.cssText = 'position:fixed;top:-1000px;opacity:0';
		document.body.appendChild(ta); ta.select();
		var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
		ta.remove(); return ok;
	}
	function shareTo(where, kind) {
		kind = kind || msgKind;
		if (where === 'whatsapp') {
			window.open('https://wa.me/?text=' + encodeURIComponent(shareText(kind, 'whatsapp')), '_blank', 'noopener');
		} else if (where === 'instagram') {
			copy(shareText(kind, 'instagram_dm')).then(function () {
				toast('Mesaj kopyalandı. Instagram’da sohbete yapıştır 💬', 3200);
				setTimeout(function () { window.open('https://www.instagram.com/direct/inbox/', '_blank', 'noopener'); }, 700);
			});
		} else if (where === 'copy') {
			copy(kind === 'link' ? shareUrl('link') : shareText(kind, 'link')).then(function (ok) { toast(ok ? 'Kopyalandı ✓' : 'Kopyalanamadı'); });
		} else if (where === 'mail') {
			location.href = 'mailto:?subject=' + encodeURIComponent(D.title) + '&body=' + encodeURIComponent(shareText(kind, 'email'));
		} else if (where === 'native') {
			var t = MSG[kind];
			navigator.share({ title: D.title, text: t ? t + '\n' + D.title : D.title, url: shareUrl('paylas') }).catch(function () {});
		}
	}
	function shareSheet() {
		var native = !!navigator.share;
		var chip = function (k, l) { return '<button type="button" class="lu-chip' + (k === msgKind ? ' is-sel' : '') + '" data-k="' + k + '">' + l + '</button>'; };
		openSheet(head('Seçtiğin renk bağlantıda kalır') +
			'<div class="lu-chips">' + chip('ask', 'Fikrini sor') + chip('gift', 'Hediye ipucu') + chip('link', 'Sadece bağlantı') + '</div>' +
			'<div class="lu-msgp" data-p></div>' +
			'<div class="lu-shg">' +
				'<button type="button" class="lu-shb lu-shb--wa" data-s="whatsapp"><span>' + WA + '</span>WhatsApp</button>' +
				'<button type="button" class="lu-shb lu-shb--ig" data-s="instagram"><span>' + IG + '</span>Instagram</button>' +
				'<button type="button" class="lu-shb" data-s="copy"><span>' + icon('link') + '</span>Kopyala</button>' +
				(native ? '<button type="button" class="lu-shb" data-s="native"><span>' + icon('more') + '</span>Diğer</button>' : '<button type="button" class="lu-shb" data-s="mail"><span>' + icon('mail') + '</span>E-posta</button>') +
			'</div>', function (b) {
				var prev = function () { var p = b.querySelector('[data-p]'); if (p) p.textContent = shareText(msgKind, 'link').replace(/\?variant=.*$/, ''); };
				prev();
				b.addEventListener('click', function (e) {
					var k = e.target.closest('[data-k]');
					if (k) { msgKind = k.getAttribute('data-k'); $$('[data-k]', b).forEach(function (x) { x.classList.toggle('is-sel', x === k); }); prev(); return; }
					var s = e.target.closest('[data-s]');
					if (s) shareTo(s.getAttribute('data-s'));
				});
			});
	}

	/* ---------- Sabit alt çubuk ---------- */
	var buyRow = $('[data-lu-buy]');
	var rowVisible = true;
	function syncFx() {
		if (!fx) return;
		var on = !rowVisible && !sheetOpen && !(lb && lb.classList.contains('is-open'));
		fx.classList.toggle('is-on', on);
		fx.setAttribute('aria-hidden', on ? 'false' : 'true');
		var b = fx.querySelector('[data-lu-atc]'); if (b) b.tabIndex = on ? 0 : -1;
		document.body.classList.toggle('lwl-ai-lift', on);
	}
	if (buyRow && 'IntersectionObserver' in window) {
		new IntersectionObserver(function (es) {
			rowVisible = es[0].intersectionRatio > 0.98;
			syncFx();
		}, { threshold: [0, 0.98, 1] }).observe(buyRow);
	}

	/* ---------- Masaüstü yapışkan panel ---------- */
	var info = $('[data-lu-info]');
	var gal = $('.lu__gal');
	function stickyTop() {
		[[info, '--lu-top'], [gal, '--lu-gtop']].forEach(function (x) {
			var el = x[0];
			if (!el) return;
			if (!mq.matches) { el.style.removeProperty(x[1]); return; }
			var hdr = document.querySelector('[id$="__header"]');
			var hb = hdr && getComputedStyle(hdr).position === 'sticky' ? hdr.offsetHeight : 0;
			var top = hb + 20;
			var h = el.offsetHeight;
			if (h + top > window.innerHeight) top = Math.min(top, window.innerHeight - h - 24);
			el.style.setProperty(x[1], top + 'px');
		});
	}
	if (window.ResizeObserver) { if (info) new ResizeObserver(stickyTop).observe(info); if (gal) new ResizeObserver(stickyTop).observe(gal); }
	window.addEventListener('resize', stickyTop);

	/* ---------- Son baktıkların ---------- */
	(function saveRecent() {
		try {
			var v = best();
			var list = JSON.parse(ls('lwlSon') || '[]').filter(function (x) { return x && x.h !== D.handle; });
			list.unshift({ h: D.handle, t: D.title, u: D.url, i: D.img4, i2: D.img2, p: v.price, c: v.cmp, n: D.colors });
			ls('lwlSon', JSON.stringify(list.slice(0, 12)));
		} catch (e) {}
	})();

	/* ---------- Başlat ---------- */
	render();
	applyMode();
	try {
		var sp = new URLSearchParams(location.search);
		if (sp.get('utm_campaign') === 'urun_paylas' && !sessionStorage.getItem('luShared')) {
			sessionStorage.setItem('luShared', '1');
			setTimeout(function () { toast('💌 Bu ürün seninle paylaşıldı', 3800); }, 900);
		}
		if (sp.get('contact_posted') === 'true') setTimeout(function () { toast('✓ Tamam! Stoğa girince haber vereceğiz.', 4000); }, 600);
	} catch (e) {}
})();
